module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'payments.show',
        params: {
          id: _vm.payment.id
        }
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('h2', {
    staticClass: "truncate"
  }, [_c('strong', [_vm._v("Payment #" + _vm._s(_vm.decorated.xero_number))]), _vm._v(" – " + _vm._s(_vm.decorated.carrier_name))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('p', {
    staticClass: "text-upper",
    class: _vm.statusClass
  }, [_vm._v(_vm._s(_vm.decorated.status))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-push-9 col-sm-3"
  }, [_c('p', [_vm._v(_vm._s(_vm.decorated.total_with_gst))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-pull-3 col-sm-9"
  }, [_c('ul', {
    staticClass: "details"
  }, [_c('li', [_c('span', [_vm._v("Created:")]), _vm._v(" " + _vm._s(_vm.decorated.created_date))]), _vm._v(" "), _c('li', [_c('span', [_vm._v("Paid On:")]), _vm._v(" " + _vm._s(_vm.decorated.paid_date))])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-3ec5584e"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/payments/PaymentItem.vue
// module id = 972
// module chunks = 0